/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationIngestionData } from '../definitions';
import type ZendeskPlatform from '../../zendesk';

export default class ZendeskConversationIngestion implements ConversationIngestionData {
  private platform: ZendeskPlatform;

  constructor(platform: ZendeskPlatform) {
    this.platform = platform;
  }

  get drawerTitle() {
    return this.platform.intl.t('standalone.common.conversation-ingestion.zendesk-ticket-history');
  }

  get syncHistoryTitle() {
    return this.platform.intl.t(
      'standalone.common.conversation-ingestion.sync-conversation-history.zendesk.title',
    );
  }

  get syncTicketHistoryLabel() {
    let instanceUrl =
      this.platform.zendeskConfig?.fullZendeskUrl ||
      this.platform.intl.t(
        'standalone.common.conversation-ingestion.sync-conversation-history.default-instance-label',
      );
    return this.platform.intl.t(
      'standalone.common.conversation-ingestion.sync-conversation-history.sync-label',
      {
        instanceUrl,
      },
    );
  }

  get disableSyncBody() {
    return this.platform.intl.t('standalone.zendesk.settings.connect.disable-sync-body');
  }

  get importingEnabledNotificationMessage() {
    return this.platform.intl.t('standalone.zendesk.settings.connect.conv-importing-enabled');
  }

  get deployCopilotRoute() {
    return 'apps.app.standalone.deploy.zendesk.copilot';
  }
}
